import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { retry, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { Usuario } from "../../vista-admin-usuario/entidades/usuario";
import { ListasReporte } from "../entidades/listas-reporte";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ServiciosService {

  constructor(private http: HttpClient) { }

  opcionesHttp = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  /**
   * @title Consultar Vicepresidencias
   */
  consultaVicepresidencias(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarVicepresidencias", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Vicepresidencias
   */
  consultaPaises(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarPaises", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Vicepresidencias
   */
  consultaGerencia(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarGerencia", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Vicepresidencias
   */
  consultarAreas(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarAreas", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Lugar
   */
  consultarLugar(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarLugar", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Lugar
   */
  consultarTipoConflicto(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarTipoConflicto", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  consultarTipoRespuesta(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarTipoPreguntaMultiple", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Lugar
   */
  generarReporte(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/generarReporte", filter, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Lugar
   */
   generarReporteAdministrativo(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/generarReporteAdministrativo", filter, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  generarReporteRespuestas(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/generarReporteRespuestas", filter, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /**
   * @title Consultar Conflictos
   */
   generarReporteconflictos(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/generarReporteConflictos", filter, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  consultarUsuariosActivos(filter): Observable<any> {
    return this.http
      .post<Usuario>(environment.apiUrl + "/Usuarios/consultarUsuariosActivos", JSON.stringify(filter), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  consultarRespuestasFuncionario(filter): Observable<any> {
    return this.http
      .post<Usuario>(environment.apiUrl + "/Funcionarios/consultarRespuestasFuncionario", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  consultarTerceros(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarTerceros", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  consultarUsuariosReport(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarUsuariosReport", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  consultarPreguntas(): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/consultarPreguntas", {}, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }
  
  generarFiltros(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/generarFiltros", JSON.stringify(filter), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  verReporte(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/verReporte", JSON.stringify(filter), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  verProceso(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/verConflicto", JSON.stringify(filter), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  listaConflictos(filter): Observable<any> {
    return this.http
      .post<ListasReporte>(environment.apiUrl + "/Usuarios/listaConflictos", JSON.stringify(filter), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  manejarError(error) {
    let mensajeError = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      mensajeError = error.error.message;
    } else {
      // Get server-side error
      mensajeError = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(mensajeError);
    return throwError(mensajeError);
  }
}
